import {
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  GET_ORDER_ADDRESSES_REQUEST,
  GET_ORDER_ADDRESSES_SUCCESS,
  GET_ORDER_ADDRESSES_FAILURE,
} from "../../constants/ActionTypes";

import { OrdersApi } from "../api/OrdersApi";

/*** GET /orders/{id} ***/
const getOrderByIdRequest = (id) => ({
  type: GET_ORDER_BY_ID_REQUEST,
  payload: {
    id: id,
  },
});

const getOrderByIdSuccess = (id, data) => ({
  type: GET_ORDER_BY_ID_SUCCESS,
  payload: {
    id: id,
    data: data,
  },
});

const getOrderByIdFailure = (error) => ({
  type: GET_ORDER_BY_ID_FAILURE,
  payload: {
    error: error,
  },
});

export function getOrderById(id, data = {}) {
  return async (dispatch) => {
    dispatch(getOrderByIdRequest(id));

    OrdersApi.getOrderById(id, data, dispatch)
      .then((response) => {
        dispatch(getOrderByIdSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(getOrderByIdFailure(error.response));
      });
  };
}

/*** GET /orders/{id}/addresses ***/
const getOrderAddressesRequest = (overwrite) => ({
  type: GET_ORDER_ADDRESSES_REQUEST,
  payload: {
    overwrite: overwrite,
  },
});

const getOrderAddressesSuccess = (addresses, pageInfo, overwrite) => ({
  type: GET_ORDER_ADDRESSES_SUCCESS,
  payload: {
    addresses: addresses,
    pageInfo: pageInfo,
    overwrite: overwrite,
  },
});

const getOrderAddressesFailure = (error) => ({
  type: GET_ORDER_ADDRESSES_FAILURE,
  payload: {
    error: error,
  },
});

export function getOrderAddresses(id, data, overwrite) {
  return async (dispatch) => {
    dispatch(getOrderAddressesRequest(overwrite));

    OrdersApi.getOrderAddresses(id, data, dispatch)
      .then((response) => {
        dispatch(
          getOrderAddressesSuccess(
            response.data.data,
            response.data.meta,
            overwrite
          )
        );
      })
      .catch((error) => {
        dispatch(getOrderAddressesFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/OrderDetail.js